import * as React from 'react'

const SvgBulbIcon = (props) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33301 14.6668H7.66634M4.66634 6.66683H7.33301M5.99967 6.66683L5.99967 10.6668M7.99967 10.2177C9.57631 9.46877 10.6663 7.86176 10.6663 6.00016C10.6663 3.42283 8.577 1.3335 5.99967 1.3335C3.42235 1.3335 1.33301 3.42283 1.33301 6.00016C1.33301 7.86176 2.42304 9.46877 3.99967 10.2177V10.6668C3.99967 11.2881 3.99967 11.5987 4.10117 11.8437C4.23649 12.1704 4.49606 12.43 4.82276 12.5653C5.06779 12.6668 5.37842 12.6668 5.99967 12.6668C6.62093 12.6668 6.93156 12.6668 7.17659 12.5653C7.50329 12.43 7.76286 12.1704 7.89818 11.8437C7.99967 11.5987 7.99967 11.2881 7.99967 10.6668V10.2177Z"
      stroke="#F79009"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgBulbIcon
